export const randomColor = (index: number) => {
  const color = `rgb(${
    randomNumber(index) + ' ' + randomNumber(index) + ' ' + randomNumber(index)
  })`;

  return color;
};

const randomNumber = (index: number) => {
  const color = index < 20 ? index * 10 : index;

  const number = Math.random() * (200 - color) + color;
  return number.toFixed(0);
};

export const colors: string[] = [
  '#D120AD',
  '#fa7126',
  '#0e007d',
  '#3D8DD9',
  '#6F58C9',
  '#033F63',
  '#e9b3f7',
  '#FDCA40',
  '#8A9B68',
  '#158FD1',
  '#F79560',
  '#302770',
  '#553FFC',
  '#2C5073',
  '#EBAB73',
  '#805F42',
  '#350a2c',
  '#E86C00',
  '#070042',
  '#033F63',
  '#FDCA40',
  '#158FD1',
  '#FF9233',
  '#B3B4B5',
  '#EBAB73',
  '#0e007d',
  '#f4e1cb',
  '#070042',
  '#b65aa3',
  '#f68b01',
  '#6F58C9',
  '#033F63',
  '#F0D3F7',
  '#FDCA40',
  '#8A9B68',
  '#158FD1',
  '#F79560',
  '#302770',
  '#553FFC',
  '#4496E3',
  '#6AA3D9',
  '#2C5073',
  '#72A6D6',
  '#FF9233',
  '#B3B4B5',
  '#EBAB73',
  '#A37145',
  '#A15A1B',
  '#fa7126',
  '#0e007d',
  '#f4e1cb',
  '#070042',
  '#f68b01',
  '#6F58C9',
  '#033F63',
  '#a00581',
  '#F0D3F7',
  '#FDCA40',
  '#8A9B68',
  '#158FD1',
  '#F79560',
  '#302770',
  '#553FFC',
  '#4496E3',
  '#6AA3D9',
  '#2C5073',
  '#FF9233',
  '#B3B4B5',
];

export const color = (index: number) => {
  const colorList = [
    '#D120AD',
    '#fa7126',
    '#0e007d',
    '#3D8DD9',
    '#6F58C9',
    '#033F63',
    '#e9b3f7',
    '#8A9B68',
    '#158FD1',
    '#F79560',
    '#302770',
    '#553FFC',
    '#2C5073',
    '#805F42',
    '#350a2c',
    '#E86C00',
    '#070042',
    '#033F63',
    '#FDCA40',
    '#158FD1',
    '#FF9233',
    '#B3B4B5',
    '#EBAB73',
    '#0e007d',
    '#f4e1cb',
    '#070042',
    '#b65aa3',
    '#f68b01',
    '#6F58C9',
    '#033F63',
    '#F0D3F7',
    '#FDCA40',
    '#8A9B68',
    '#158FD1',
    '#F79560',
    '#302770',
    '#553FFC',
    '#4496E3',
    '#6AA3D9',
    '#2C5073',
    '#72A6D6',
    '#FF9233',
    '#B3B4B5',
    '#EBAB73',
    '#A37145',
    '#A15A1B',
    '#fa7126',
    '#0e007d',
    '#f4e1cb',
    '#070042',
    '#f68b01',
    '#6F58C9',
    '#033F63',
    '#a00581',
    '#F0D3F7',
    '#FDCA40',
    '#8A9B68',
    '#158FD1',
    '#F79560',
    '#302770',
    '#553FFC',
    '#4496E3',
    '#6AA3D9',
    '#2C5073',
    '#FF9233',
    '#B3B4B5',
  ];

  return colorList[index];
};
